@if (isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    <my-ibox boxTitle="IRC Bridge Configurations">
      <div class="my-ibox-content">
        <p>
          <a href="https://github.com/matrix-org/matrix-appservice-irc" target="_blank">{{'matrix-appservice-irc' | translate}}</a>
          {{'is an IRC bridge that supports multiple IRC networks. Dimension is capable of using multiple IRC bridges to better distribute the load across multiple networks in large deployments.' | translate}}
        </p>

        <table class="table table-striped table-condensed table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>{{'Enabled Networks' | translate}}</th>
              <th class="text-center" style="width: 120px;">{{'Actions' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            @if ((!configurations || configurations.length === 0)) {
              <tr>
                <td colspan="3"><i>{{'No bridge configurations.' | translate}}</i></td>
              </tr>
            }
            @for (bridge of configurations; track bridge) {
              <tr>
                <td>
                  {{ bridge.upstreamId ? "matrix.org's bridge" : "Self-hosted bridge" }}
                  @if (!bridge.upstreamId) {
                    <span class="text-muted" style="display: inline-block;"
                    >({{ bridge.provisionUrl }})</span>
                  }
                </td>
                @if (bridge.isOnline) {
                  <td>
                    {{ getEnabledNetworksString(bridge) }}
                  </td>
                }
                @if (!bridge.isOnline) {
                  <td class="error-text" colspan="2">
                    <i class="fa fa-exclamation-triangle"></i>
                    {{'This bridge is offline or unavailable.' | translate}}
                  </td>
                }
                @if (bridge.isOnline) {
                  <td class="text-center">
                    <span class="editButton" (click)="editNetworks(bridge)">
                      <i class="fa fa-pencil-alt"></i>
                    </span>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        @if (!hasModularBridge) {
          <button type="button" class="btn btn-success btn-sm" (click)="addModularHostedBridge()"
            >
            <i class="fa fa-plus"></i> {{'Add matrix.org\'s bridge' | translate}}
          </button>
        }
        <button type="button" class="btn btn-success btn-sm" (click)="addSelfHostedBridge()">
          <i class="fa fa-plus"></i> {{'Add self-hosted bridge' | translate}}
        </button>
      </div>
    </my-ibox>
  </div>
}
